import {useLazyQuery} from '@apollo/client';
import {reportsQueries} from 'api/graphql-queries/reports';
import {TicketBoardReportRequest, TicketBoardReportResponse} from 'models/reports/ticketBoardUserAssignmentReport';

export const useGetTicketBoardUserInfoReportApi = () => {
    const [refetch, {data, loading}] = useLazyQuery<TicketBoardReportResponse, TicketBoardReportRequest>(
        reportsQueries.GET_TICKET_BAORD_USER_INFO_REPORT,
        {
            fetchPolicy: 'no-cache',
        },
    );

    return {
        getTicketBoardUserInfoReport: refetch,
        getTicketBoardUserInfoReportResponse: data?.ticketBoardUserInfoReport,
        getTicketBoardUserInfoReportLoading: loading,
    };
};
